import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadFaqMySites } from '@/redux/actions/faq';
import { SUPPORT_URL } from '@/config/urls/supportUrls';
import FaqDefault from '@/components/FrequentlyQuestions/FaqDefault';


const FaqMySites = ({ className }) => {
  const faq = useSelector(state => state.faq);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadFaqMySites());
  }, [dispatch]);

  return (
    <FaqDefault
      questions={faq.mySites.questions}
      link={SUPPORT_URL}
      className={className}
      loading={faq.loading}
    />
  );
};

export default FaqMySites;
